import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { removeFromCart, removeFromGuestCart } from "../store"
import "./styles/CartItem.css"

const RemoveFromCartButton = (props) => {
  const dispatch = useDispatch()
  const auth = useSelector((state) => state.auth)
  const handleClick = () => {
    if (auth.id) {
      dispatch(removeFromCart(props))
    } else {
      dispatch(removeFromGuestCart(props))
    }
  }
  return (
    <div className="flex w-full flex-row-reverse p-2">
      <button onClick={() => handleClick()} className="remove-cart-btn">
        Remove
      </button>
    </div>
  )
}

export default RemoveFromCartButton
